import _ from "../../../../@lodash";
import BASEUtils from "../../../../@BASE/utils/BASEUtils";

const SectionModel = (data) =>
  _.defaults(data || {}, {
    title: "",
    label: "",
    classification: "normal",
    progress: {
      development: 0,
      production: 0,
    },
    status: {
      development: "not_started",
      production: "not_started",
    },
    order: 0,
    user: "",
    lesson: "",
    navigation: [],
  });

export default SectionModel;
